"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _excluded = ["className", "disabled", "error", "focus", "multiline", "valid"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "styledInput": "_6zoPYf",
  "multiline": "_9Q-7dl",
  "disabled": "LVUu67",
  "focus": "TmlwOv",
  "valid": "rUwhoK",
  "error": "vTes0l"
};
var StyledInput = exports.StyledInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    focus = _ref.focus,
    multiline = _ref.multiline,
    valid = _ref.valid,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, props, {
    ref: ref,
    className: (0, _clsx["default"])(className, styles.styledInput, disabled && styles.disabled, error && styles.error, valid && styles.valid, focus === 'true' && styles.focus, multiline && styles.multiline),
    disabled: disabled,
    error: error,
    multiline: multiline
  }));
});
StyledInput.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  valid: _propTypes["default"].bool
};
var _default = exports["default"] = StyledInput;